/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSpiderDataItem
 */
export interface CRSFSpiderDataItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSpiderDataItem
     */
    first_seen: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSpiderDataItem
     */
    last_seen: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSpiderDataItem
     */
    malware_type: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSpiderDataItem
     */
    num_ports_affected: number;
}

/**
 * Check if a given object implements the CRSFSpiderDataItem interface.
 */
export function instanceOfCRSFSpiderDataItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_seen" in value;
    isInstance = isInstance && "last_seen" in value;
    isInstance = isInstance && "malware_type" in value;
    isInstance = isInstance && "num_ports_affected" in value;

    return isInstance;
}

export function CRSFSpiderDataItemFromJSON(json: any): CRSFSpiderDataItem {
    return CRSFSpiderDataItemFromJSONTyped(json, false);
}

export function CRSFSpiderDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSpiderDataItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_seen': json['first_seen'],
        'last_seen': json['last_seen'],
        'malware_type': json['malware_type'],
        'num_ports_affected': json['num_ports_affected'],
    };
}

export function CRSFSpiderDataItemToJSON(value?: CRSFSpiderDataItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_seen': value.first_seen,
        'last_seen': value.last_seen,
        'malware_type': value.malware_type,
        'num_ports_affected': value.num_ports_affected,
    };
}

